import router from './router/index'
import store from './store'
//import router from './router'
import ParseRoutes from "./router/parse_routes"
import {
  getToken,
  removeToken
} from './utils/auth' // 验权
router.beforeEach((to, from, next) => {

  console.log(to); // 即将要进入路由的对象
  console.log(from); // 当前导航要离开的路由对象
  console.log(next); // 调用next该方法，才能进入下一个路由
  var url = decodeURIComponent(location.search);

  //    let menusMap = ParseRoutes(router.options.routes)
  // const routes = Object.values(menusMap)
  // // 默认路由拼接生成的路由（注意顺序）
  // //const integralRoutes = defRoutes.concat(routes)
  // router.options.routes = routes

  if (window.location.href.indexOf('code') >= 0) {
    //如果url中包含code,则保存到store中
    let code = window.location.href.split("?")[1];
    code = code.substring(5, code.indexOf('&'));
    store.state.code = code;
    console.log("code:" + code);
  }

  if (to.path != "/mobile") {
    const mobile = JSON.parse(sessionStorage.getItem('ismobile'))
    if (mobile == "1") {
      next('/mobile')
    }
  }

  if (to.path === "/logout") {
    store.dispatch('logout').then(res => {
      debugger
      router.go(0)
      next('/Home')
    })
  }
  // if(to.path === "/Franchisee")
  // {
  // 	location.href = 'http://github.com'
  // }
  if (store.getters.roles.length == 0) {
    if (sessionStorage.getItem('userinfo') != "undefined" && sessionStorage.getItem('userinfo') != null) {
      var userinfo = JSON.parse(sessionStorage.getItem('userinfo'))
      const menus = [ // 由后端传入
        {
          "id": 4,
          "pid": 0,
          "path": "/",
          "name": "me", //GoodsManage
          //"component": "GoodsManage",
          "redirect": "",
          "hidden": "true",
          "meta": "{\"title\": \"欢迎:" + userinfo.username + "\"}"
        },
        {
          "id": 41,
          "pid": 4,
          "path": "/shoppingcart",
          "name": "shoppingcart",
          //"component": "GoodsInfo",
          "redirect": "",
          "hidden": "true",
          "meta": "{\"title\": \"购物车\"}"
        }, ,
        {
          "id": 42,
          "pid": 4,
          "path": "/CoursewareList",
          "name": "CoursewareList",
          //"component": "GoodsInfo",
          "redirect": "",
          "hidden": "true",
          "meta": "{\"title\": \"我的课程\"}"
        },

        {
          "id": 43,
          "pid": 4,
          "path": "/myorder",
          "name": "myorder",
          //"component": "GoodsInfo",
          "redirect": "",
          "hidden": "true",
          "meta": "{\"title\": \"我的订单\"}"
        },
        {
          "id": 44,
          "pid": 4,
          "path": "/logout",
          "name": "logout",
          //"component": "GoodsInfo",
          "redirect": "",
          "hidden": "true",
          "meta": "{\"title\": \"退出\"}"
        },
        {
          "id": 49,
          "pid": 4,
          "path": "/addressInfo",
          "name": "addressInfo",
          //"component": "GoodsInfo",
          "redirect": "",
          "hidden": "false",
          "meta": "{\"title\": \"添加地址\"}"
        },
        {
          "id": 99,
          "pid": 0,
          "path": "/login",
          "name": "login",
          //"component": "GoodsInfo",
          "redirect": "",
          "hidden": "false",
          "meta": "{\"title\": \"登录/注册\"}"

        },
      ]
      let menusMap = ParseRoutes(menus)

      // 将生成数组树结构的菜单
      const routes = Object.values(menusMap)

      // 默认路由拼接生成的路由（注意顺序）
      let temp = router.options.routes
      for (var i = 0; i < temp.length; i++) {
        for (var j = 0; j < routes.length; j++) {
          if (temp[i].id == routes[j].id) {
            temp[i] = routes[j]
          }
        }
      }
      //const integralRoutes = router.options.routes.concat(routes)
      router.options.routes = temp
      store.dispatch('SetRoles', {
        menus
      }).then(() => { // 根据roles权限生成可访问的路由表

        router.addRoutes(routes)

        next({ ...to,
          replace: true
        })
      })
    }
  } else {
    //next()
  }
  let whiteList = ['/login', '/shoppingcart', '/adduserinfo', '/CoursewareList', '/CoursewareInfo', "/settlement",
    "/pay", "/myorder"
  ]
  //let whiteList=['/login']

  if (whiteList.indexOf(to.path) != -1) {
    if (getToken()) {
      if (to.path === '/login') {
        removeToken();
        sessionStorage.clear();
        next()
      } else {
        //next();
        //const unparseRoutes = JSON.parse(sessionStorage.getItem('userinfo'))
        //if(unparseRoutes)
        // 				if (store.getters.roles.length != 0) {
        // 					if (to.meta.empower != null) {
        // 						next()
        // 					} else {
        // 						// next({
        // 						// 	path: '/404',
        // 						// 	replace: true,
        // 						// 	query: {
        // 						// 		noGoBack: true
        // 						// 	}
        // 						// })
        // 						next('/Home')
        // 					}
        //
        // 				} else {
        // 					next()
        // 				}
        next()
        //next({ ...to, replace: true })

        //next({ ...to, replace: true })
      }
    } else {
      if (to.path === '/login') {
        next()
      } else {
        next('/login')
        //NProgress.done()
      }
    }
  } else {
    if (to.path == '/Online' && (JSON.stringify(to.params) == "{}")) {
      next({
        name: 'Online',
        params: {
          type: '0002'
        }
      })
    } else if (to.path == '/Offline' && (JSON.stringify(to.params) == "{}")) {
      next({
        name: 'Offline',
        params: {
          type: '0003'
        }
      })
    } else if (to.path == '/Books' && (JSON.stringify(to.params) == "{}")) {
      next({
        name: 'Books',
        params: {
          type: '0001'
        }
      })
    } else if (to.path == '/Instrument' && (JSON.stringify(to.params) == "{}")) {
      next({
        name: 'Instrument',
        params: {
          type: '0000'
        }
      })
    } else {
      next()
    }

  }


  //next();
});



// WEBPACK FOOTER //
// ./src/permission.js